import { Navigate, Route, Routes } from "react-router-dom"
import { HelpOverview } from "./HelpOverview"
import { HelpSection } from "./HelpSection"

const Help: React.FC = () => {
  return (
    <Routes>
      <Route index element={<HelpOverview />} />
      <Route path=":section" element={<HelpSection />} />
      <Route path="*" element={<Navigate to="/help" replace />} />
    </Routes>
  )
}

export default Help
